/* Product information accordions: animate from the currently painted height.
   Capture only these summaries; the cart and other theme accordions stay native. */
(() => {
  const states = new WeakMap();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function toggle(details, opening) {
    const body = details.querySelector('[data-collapsible-body]');
    const content = details.querySelector('[data-collapsible-content]');
    if (!body || !content) return;
    const previous = states.get(details);
    const from = details.open ? body.getBoundingClientRect().height : 0;
    previous?.animation?.cancel();
    const state = {opening, animation:null};
    states.set(details,state);
    body.dataset.vnkSmoothBody='';
    details.open=true;
    const to=opening ? content.getBoundingClientRect().height : 0;
    body.style.height=from+'px';
    const settle=()=>{
      if(states.get(details)!==state)return;
      details.open=opening;
      body.style.height=opening?'auto':'';
      state.animation?.cancel();
      state.animation=null;
      details.dispatchEvent(new CustomEvent('theme:form:sticky',{bubbles:true,detail:{element:'accordion'}}));
    };
    if(motion.matches || !body.animate || Math.abs(to-from)<1) { settle(); return; }
    try {
      state.animation=body.animate([{height:from+'px'},{height:to+'px'}],{
        duration:matchMedia('(max-width:749px)').matches ? Math.min(320,220+Math.abs(to-from)*.1) : Math.min(580,360+Math.abs(to-from)*.18),
        easing:'cubic-bezier(.22,.68,.28,1)',fill:'both'
      });
      state.animation.finished.then(settle,()=>{});
    } catch (_) { settle(); }
  }
  document.addEventListener('click',event=>{
    const summary=event.target.closest?.('.template-product .vnk-info-accordion summary[data-collapsible-trigger]');
    if(!summary || event.target.closest('a,button,input,select,textarea'))return;
    const details=summary.closest('details');
    if(!details?.querySelector('[data-collapsible-content]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    const state=states.get(details);
    toggle(details,!(state?.animation?state.opening:details.open));
    details.dispatchEvent(new CustomEvent('theme:collapsible:toggle',{bubbles:true}));
  },true);
})();
